export default __webpack_public_path__ + "static/media/settings-header.f6cd1a53.png";